import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator, sendEmailVerification, sendPasswordResetEmail } from "firebase/auth";

const firebaseConfig = JSON.parse(atob(process.env.REACT_APP_FIREBASE_CONFIG));

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// initialize authentication
const auth = getAuth(app);

if (process.env.NODE_ENV === 'development') {
    connectAuthEmulator(auth, process.env.REACT_APP_EMULATOR_HOST, { disableWarnings: false });
}

export { auth };

export const sendVerificationEmail = async (user) => {
    if (user) {
        sendEmailVerification(user)
            .then(() => {
                return true;
            })
            .catch((error) => {
                return { error: error.message };
            });
    } else {
        return { error: 'User not found' };
    }
};

export const sendPasswordReset = async (email) => {
    await sendPasswordResetEmail(auth, email)
        .then(() => {
            return true;
        })
        .catch((error) => {
            return { error: error.message };
        });
};
